import React from 'react'

import { withStyles } from '@material-ui/core/styles'
import get from 'lodash/get'
import isNil from 'lodash/isNil'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

import * as PoziUtils from 'api/utils'
import AccordionWrapper from 'drawer/tabs/AccordionWrapper'
import { setLayerPanelsFeatureOpen } from 'drawer/tabs/layers/actions'
import { endAnnotation } from 'drawer/tabs/layers/annotations/actions'
import { PANEL_TITLE_DEFAULT, PANEL_TITLE_TABLE } from 'drawer/tabs/layers/panels/LayerPanels'

const styles = theme => ({
  accordionWrapperRoot: {
    padding: 0
  }
})

class LayerPanelsExpansion_ extends React.Component {
  constructor (props) {
    super(props)
    const { titleid, panelTitle, headerIcon, rootClass } = this.props
    this.pure = {}
    // Used to set the current opening element back onto page if the one above collapsed pulling the current on off the screen.
    this.pure.panelId = PoziUtils.getPoziIDFromString(titleid + '_' + panelTitle)
    this.pure.headerIcon = headerIcon
    this.pure.handleExpansionPanelChange = this.handleExpansionPanelChange.bind(this)
    this.pure.rootClass = rootClass

    if (panelTitle === PANEL_TITLE_DEFAULT) {
      setLayerPanelsFeatureOpen(titleid, panelTitle)
    }
  }

  // Stop any current annotations if a panel open or closes.
  endAnnotationsOnPanelOpenClose () {
    const { annotationType, endAnnotation } = this.props
    if (annotationType !== '') {
      endAnnotation()
    }
  }

  // Used to set the current opening element back onto page if the one above collapsed pulling the current on off the screen.
  scrollToElement = (target, panelTitle) => {
    if (!this.isElementCompletelyInView(target)) {
      const { titleid } = this.props
      const panelId = '#' + this.getPanelId(titleid, panelTitle)
      // https://stackoverflow.com/questions/5007530/how-do-i-scroll-to-an-element-using-javascript
      window.location.href = '#'
      window.location.href = panelId
    }
  }

  // Used to set the current opening element back onto page if the one above collapsed pulling the current on off the screen.
  isElementCompletelyInView (el) {
    const rect = el.getBoundingClientRect()
    const elemTop = rect.top
    const elemBottom = rect.bottom
    // Only completely visible elements return true:
    const isVisible = elemTop >= 0 && elemBottom <= window.innerHeight
    // Partially visible elements return true:
    // isVisible = elemTop < window.innerHeight && elemBottom >= 0;
    return isVisible
  }

  handleExpansionPanelChange (event) {
    const { setLayerPanelsFeatureOpen, titleid, panelTitle, panelFeatureTitle, cb } = this.props

    this.endAnnotationsOnPanelOpenClose()

    let bPanelOpening = false
    if (panelTitle === panelFeatureTitle) {
      setLayerPanelsFeatureOpen(titleid, '')
    } else {
      setLayerPanelsFeatureOpen(titleid, panelTitle)
      const target = event.target
      window.setTimeout(this.scrollToElement, 500, target, panelTitle)
      bPanelOpening = true
    }

    if (!isNil(cb)) {
      cb(bPanelOpening)
    }
  }

  render () {
    const { panelTitle, panelFeatureTitle, markup, licensed = true, bBackClicked } = this.props

    const bExpanded = panelTitle === panelFeatureTitle
    let renderMarkupIfExpanded = null
    if (bExpanded) {
      renderMarkupIfExpanded = markup
    }

    let bSlideDisabled = true
    let bBackClickedFinal = null
    if (!isNil(bBackClicked)) {
      bSlideDisabled = false
      bBackClickedFinal = bBackClicked
    }

    return (
      <AccordionWrapper
        bSlideDisabled={bSlideDisabled}
        bSlideDirectionLeft={bBackClickedFinal}
        rootClass={this.pure.rootClass}
        bExcludeExpandIcon={true}
        id={this.pure.panelId}
        expanded={bExpanded}
        onChange={this.pure.handleExpansionPanelChange}
        headerIcon={this.pure.headerIcon}
        title={panelTitle}
        licensed={licensed}
      >
        {renderMarkupIfExpanded}
      </AccordionWrapper>
    )
  }
}

LayerPanelsExpansion_.propTypes = {
  rootClass: PropTypes.string,
  titleid: PropTypes.string.isRequired,
  panelFeatureTitle: PropTypes.string.isRequired,
  panelTitle: PropTypes.string.isRequired,
  licensed: PropTypes.bool,
  markup: PropTypes.object,
  setLayerPanelsFeatureOpen: PropTypes.func.isRequired,
  headerIcon: PropTypes.object.isRequired,
  annotationType: PropTypes.string,
  endAnnotation: PropTypes.func.isRequired,
  cb: PropTypes.func, // Callback
  bBackClicked: PropTypes.bool
}

function mapStateToProps (state, ownProps) {
  const panelFeatureTitle = get(state, 'layers[' + ownProps.titleid + '].panelFeatureTitle', '')
  return {
    panelFeatureTitle
  }
}

const mapDispatchToProps = dispatch => {
  return {
    endAnnotation: () => {
      dispatch(endAnnotation())
    },
    setLayerPanelsFeatureOpen: (titleid, panelFeatureTitle) => {
      dispatch(setLayerPanelsFeatureOpen(titleid, panelFeatureTitle))
    }
  }
}

const LayerPanelsExpansion = withStyles(styles)(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(LayerPanelsExpansion_)
)

export default LayerPanelsExpansion
